import React, { type ReactNode, createContext } from 'react';

import { DiscardDialog } from 'src/app/v1/views/components/DiscardDialog';
import { useDiscardDialog } from 'src/app/v1/views/components/DiscardDialog/useDiscardDialog';

type Context = {
  openDialog: () => void;
};

export const DiscardDialogContext = createContext<Context>({
  openDialog: () => {},
});

interface Props {
  children: ReactNode;
}

export const DiscardDialogProvider = ({ children }: Props) => {
  const { isOpen, openDialog, closeDialog, onDiscard } = useDiscardDialog();

  return (
    <DiscardDialogContext.Provider value={{ openDialog }}>
      {children}

      <DiscardDialog
        isOpen={isOpen}
        onClose={closeDialog}
        onDiscard={onDiscard}
      />
    </DiscardDialogContext.Provider>
  );
};
